import { KEEP_STATIC_CODES_SAFE, THESE_ARE_YOUR_NEW_BACKUP_CODES, USE_BACKUP_CODES } from 'common/constants/auth';
import { Grid } from 'components/ui';
import {
  BACKUP_CODES_DESCRIPTION_ID,
  BACKUP_CODES_TITLE_ID,
} from 'pages/Auth/components/BackupCodes/BackupCodes.constants';
import {
  BackupCodesSubtitle,
  BackupCodesSupportingText,
  BackupCodesTitle,
  CenterContainer,
  GridItem,
  HiddenGrid,
  Logo,
  PrintableContainer,
  PrintLogo,
  StyledPrintGrid,
} from 'pages/Auth/components/BackupCodes/BackupCodes.styles';
import { BackupCodesInfo } from '..';
import type { PrintableBackupCodesProps } from './PrintableBackupCodes.props';

const PrintableBackupCodes = ({
  backupCodes,
  componentRef,
  disabledGenerate = false,
  forPrint,
  isAuthFlowStep = false,
  isGeneratingBackupCodes,
  username = '',
}: PrintableBackupCodesProps) => {
  const useCompactBackupCodesLayout = isAuthFlowStep;
  const ContainerComponent = forPrint ? HiddenGrid : PrintableContainer;
  const GridComponent = forPrint ? StyledPrintGrid : CenterContainer;
  const shouldRenderDocumentTitle = Boolean(forPrint);
  const descriptionId = !forPrint ? BACKUP_CODES_DESCRIPTION_ID : undefined;

  return (
    <ContainerComponent>
      <GridComponent ref={componentRef || undefined} container>
        {forPrint && (
          <PrintLogo>
            <Logo as="img" alt="Background" src="/images/logos/scalar-logo.jpg" />
          </PrintLogo>
        )}

        <GridItem
          size={{ xs: 12, lg: useCompactBackupCodesLayout ? 12 : 6 }}
          className={useCompactBackupCodesLayout ? 'compact' : 'regular'}
        >
          {shouldRenderDocumentTitle && (
            <BackupCodesTitle id={BACKUP_CODES_TITLE_ID} variant="h6">
              {THESE_ARE_YOUR_NEW_BACKUP_CODES}
              {username ? ` for ${username}` : null}
            </BackupCodesTitle>
          )}

          <BackupCodesSubtitle>{KEEP_STATIC_CODES_SAFE}</BackupCodesSubtitle>

          <BackupCodesSupportingText id={descriptionId}>{USE_BACKUP_CODES}</BackupCodesSupportingText>
        </GridItem>

        <Grid size={{ xs: 12, lg: useCompactBackupCodesLayout ? 12 : 6 }}>
          <BackupCodesInfo
            backupCodes={backupCodes}
            disabledGenerate={disabledGenerate}
            isAuthFlowStep={isAuthFlowStep}
            isGeneratingBackupCodes={isGeneratingBackupCodes}
          />
        </Grid>
      </GridComponent>
    </ContainerComponent>
  );
};

export default PrintableBackupCodes;
